<div class="row osiptel-login-cabecera">
    <div class="col-10 offset-1 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-xl-4 offset-xl-4 p-0">
      <h1 class="font-weight-bold">BADMINTON</h1>
      <h2>Sistema de Administración de Aula Virtual</h2>
    </div>
  </div>
  
  <div class="row">
      <div class="card col-10 offset-1 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-xl-4 offset-xl-4 p-0">
        <div class="card-header">
          <h4 class="text-center">INICIAR SESIÓN</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="form">
            <div class="form-group">
              <label>Usuario</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text"> <i class="fa fa-user"></i> </span>
                </div>
                <input name="" class="form-control" placeholder="usuario" type="text" formControlName="user_vc_login">
              </div>
            </div> <!-- form-group// -->
            <div class="form-group">
              <label>Contraseña</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text"> <i class="fa fa-lock"></i> </span>
                </div>
                <input class="form-control" placeholder="******" type="password" formControlName="user_tx_password">
              </div>
            </div> <!-- form-group// -->
            <div class="form-group">
              <button class="btn btn-primary btn-block" (click)="login()"> Ingresar</button>

              
            </div> <!-- form-group// -->
          </form>
        </div>
      </div> <!-- card.// -->
  </div>
  

 